import { travelData } from "../../state/travelData";
import { trackImpression } from "../../tracker/EventTracker";
import { data } from "@escapio/shared/state/payload";
import * as Board from "../board";
import * as Classification from "@escapio/portal/components/classification";

export const trackNoPrice = (action, filters) => {
	let travelFilter = [];
	if (filters.price) {
		travelFilter.push(`bis ${filters.price} ${travelData.currency}`);
	}
	if (filters.reviewScore) {
		travelFilter.push(`Gästebewertungen ab ${filters.reviewScore}%`);
	}
	if (filters.board == Board.BREAKFAST) {
		travelFilter.push("inkl. Frühstück");
	}
	if (filters.board == Board.HALF_BOARD) {
		travelFilter.push("Halbpension");
	}
	if (filters.cancelation) {
		travelFilter.push("kostenlos stornierbar");
	}
	if (filters.classification !== Classification.ALL) {
		travelFilter.push(Classification.TRACKING_LABELS[filters.classification]);
	}

	let extendedFilter = [];
	if (filters.criteria.length) {
		extendedFilter.push("Ausstattung: " + filters.criteria.join(", "));
	}
	if (filters.hotelTypes.length) {
		extendedFilter.push("Hoteltypen: " + filters.hotelTypes.join(", "));
	}

	trackImpression(
		"Preisvergleich Kein Preis",
		`${action}: ${data.trackingId} | ${data.prepositionedArticleTitle}`,
		[
			travelData.formattedRequestParameter.dates,
			`Gäste ${travelData.formattedRequestParameter.rooms}`,
			travelFilter.join(", "),
			extendedFilter.join(" | "),
		]
			.filter(entry => entry != "")
			.join(" | "),
	);
};
